"use strict";import{tag as e}from"../custom-tag.js";export function tutorialIcon({height:l=16,width:t=16,hidden:r=!1,title:a="Tutorial"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <path
        fill="currentColor"
        d="M16.2 9.375H7.8v.45h8.4zm0 1.8H7.8v.45h8.4zm0 1.8H7.8v.45h8.4zm-2.4 1.8h-6v.45h6zm4.5 6.45a2.924 2.924 0 1 0 0-5.848 2.924 2.924 0 0 0 0 5.848m0-5.4a2.475 2.475 0 1 1 0 4.95 2.475 2.475 0 0 1 0-4.95"
      />
      <path
        fill="currentColor"
        d="M18 19.425a.22.22 0 0 0 .16-.066l1.8-1.8-.32-.318-1.64 1.64-.74-.74-.32.318.9.9a.22.22 0 0 0 .16.066m.225-5.025V7.2a.23.23 0 0 0-.066-.16l-4.2-4.2a.23.23 0 0 0-.16-.065H6A.225.225 0 0 0 5.776 3v18a.225.225 0 0 0 .225.225h9v-.45H6.225V3.225h7.35V7.2a.225.225 0 0 0 .225.225h3.975V14.4zm-4.2-7.425V3.543l3.432 3.432z"
      />
    </svg>
  `}
//# sourceMappingURL=tutorial.js.map
